var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_5583_580","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"20","height":"21","key":0},React.createElement("rect",{"y":"0.5","width":"20","height":"20","fill":"#D9D9D9"})),React.createElement("g",{"mask":"url(#mask0_5583_580)","key":1},React.createElement("path",{"d":"M8.10417 14.9375L4.0625 10.9167L5.125 9.83333L8.10417 12.8125L14.875 6.0625L15.9375 7.125L8.10417 14.9375Z","fill":"#4E4E4E"}))]);
}

Check.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = Check;

Check.default = Check;
